import type { FindOperationsInput } from '@travel-planner/shared/schemas/operations';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

const SIXTY_SECONDS = 60 * 1000;

/**
 * Batch count poll for a whole filter-card row. One `operations.countMany`
 * round-trip instead of N× `operations.list` — same filter engine + exact-count
 * invariant, plus the server-side 30s TTL cache.
 */
export const useFilterCardCounts = (queries: FindOperationsInput[]) =>
  trpc.operations.countMany.useQuery(
    {
      queries: queries.map((q) => ({
        ...q,
        offset: 0,
        limit: 1,
        countOnly: true,
        includeRowTotal: undefined,
      })),
    },
    {
      enabled: queries.length > 0,
      staleTime: SIXTY_SECONDS,
      refetchInterval: SIXTY_SECONDS,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
      // Unbatch so the item list is not gated behind all card totals.
      trpc: { context: { skipBatch: true } },
    }
  );
